import Vue from 'vue';
import Router from 'vue-router';
// component
import sample from './views/Sample.vue';

import careLogin from './views/CareLogin.vue';
import adminLogin from './views/adminLogin.vue';
import CenterMain from './views/madmin/CenterMain.vue';
import adminRefuseNum from './views/madmin/business/adminRefuseNum.vue';
import businessCenterEdit from './views/madmin/business/center/Edit.vue';
import businessCenterList from './views/madmin/business/center/List.vue';
import businessCenterContractList from './views/madmin/business/center/ContractList.vue';
import businessChainList from './views/madmin/business/chain/List.vue';
import businessContractDetail from './views/madmin/business/contract/Detail.vue';
import businessContractEdit from './views/madmin/business/contract/Edit.vue';
import businessContractExtension from './views/madmin/business/contract/Extension.vue';
import businessContractList from './views/madmin/business/contract/List.vue';
import businessContractProduct from './views/madmin/business/contract/Product.vue';
import businessContractRefund from './views/madmin/business/contract/Refund.vue';
import businessSmsNumSetting from './views/madmin/business/smsNumSetting.vue';
import notiBasic from './views/madmin/noti/basic.vue';
import notiTalk from './views/madmin/noti/talk.vue';
import notiTemplate from './views/madmin/noti/template.vue';
import notiStatus from './views/madmin/noti/status.vue';
import businessSmsPayment from './views/madmin/business/smsPayment.vue';
import businessFitpayList from './views/madmin/business/fitpay/List.vue';
import employeeEdit from './views/madmin/employee/Edit.vue';
import employeeList from './views/madmin/employee/List.vue';
import manualDetail from './views/madmin/manual/Detail.vue';
import manualEdit from './views/madmin/manual/Edit.vue';
import manualList from './views/madmin/manual/List.vue';
import memberAccount from './views/madmin/member/Account.vue';
import memberAdvice from './views/madmin/member/Advice.vue';
import memberAttend from './views/madmin/member/Attend.vue';
import memberCancel from './views/madmin/member/Cancel.vue';
import memberConsult from './views/madmin/member/Consult.vue';
import memberConsultDetail from './views/madmin/member/ConsultDetail.vue';
import memberEdit from './views/madmin/member/Edit.vue';
import memberInfo from './views/madmin/member/Info.vue';
import memberList from './views/madmin/member/List.vue';
import memberLocker from './views/madmin/member/Locker.vue';
import memberLockerEdit from './views/madmin/member/LockerEdit.vue';
import memberMessage from './views/madmin/member/Message.vue';
import memberMileage from './views/madmin/member/Mileage.vue';
import memberPayment from './views/madmin/member/Payment.vue';
import memberPeriod from './views/madmin/member/Period.vue';
import memberContractSend from './views/madmin/member/ContractSend.vue';
import messageChargeCall from './views/madmin/message/ChargeCall.vue';
import messageHistory from './views/madmin/message/History.vue';
import payComplete from './views/madmin/message/PayComplete.vue';
//import messageRefuseNum from './views/madmin/message/RefuseNum.vue';
import memberSign from './views/madmin/member/Sign.vue';
import messageSend from './views/madmin/message/Send.vue';
import messageSendAlert from './views/madmin/message/SendAlert.vue';
import messageSendAuto from './views/madmin/message/SendAuto.vue';
import messageSettingAuto from './views/madmin/message/SettingAuto.vue';
import messageSettingOften from './views/madmin/message/SettingOften.vue';
import messageSmsCharge from './views/madmin/message/SmsCharge.vue';
import noticeDetail from './views/madmin/notice/Detail.vue';
import noticeEdit from './views/madmin/notice/Edit.vue';
import noticeList from './views/madmin/notice/List.vue';
import popupDetail from './views/madmin/popup/Detail.vue';
import popupEdit from './views/madmin/popup/Edit.vue';
import popupList from './views/madmin/popup/List.vue';
import qnaDetail from './views/madmin/qna/Detail.vue';
import qnaEdit from './views/madmin/qna/Edit.vue';
import qnaList from './views/madmin/qna/List.vue';
import questionDetail from './views/madmin/question/Detail.vue';
import questionEdit from './views/madmin/question/Edit.vue';
import questionList from './views/madmin/question/List.vue';
import scheduleTeacher from './views/madmin/schedule/Teacher.vue';
import SettingEmployeeCheck from './views/madmin/setting/EmployeeCheck.vue';
import SettingMemberGroup from './views/madmin/setting/MemberGroup.vue';
import SettingMemberNoticeDetail from './views/madmin/setting/MemberNoticeDetail.vue';
import SettingMemberNoticeEdit from './views/madmin/setting/MemberNoticeEdit.vue';
import SettingMemberNoticeList from './views/madmin/setting/MemberNoticeList.vue';
import SettingMemberPopDetail from './views/madmin/setting/MemberPopDetail.vue';
import SettingMemberPopEdit from './views/madmin/setting/MemberPopEdit.vue';
import SettingMemberPopList from './views/madmin/setting/MemberPopList.vue';
import SettingCenterFitpay from './views/madmin/setting/CenterFitpay.vue';
import CourseAccount from './views/madmin/course/Account.vue';
import CourseCare from './views/madmin/course/Care.vue';
import CourseCareHistory from './views/madmin/course/CareHistory.vue';
import CourseCareReserve from './views/madmin/course/CareReserve.vue';
import CourseHistory from './views/madmin/course/History.vue';
import CourseLesson from './views/madmin/course/Lesson.vue';
import ScheduleDay from './views/madmin/schedule/Day.vue';
import ScheduleGroup from './views/madmin/schedule/Group.vue';
import scheduleRoom from './views/madmin/schedule/Room.vue';
import SettingAdvertisement from './views/madmin/setting/Advertisement.vue';
import SettingAuthor from './views/madmin/setting/Author.vue';
import SettingAuthorDetail from './views/madmin/setting/AuthorDetail.vue';
import SettingCenterAccount from './views/madmin/setting/CenterAccount.vue';
import SettingCenterPaymentList from './views/madmin/setting/CenterPaymentList.vue';
import SettingCenterPaymentMethod from './views/madmin/setting/CenterPaymentMethod.vue';
import SettingCenterEdit from './views/madmin/setting/CenterEdit.vue';
import SettingCenterHoliday from './views/madmin/setting/CenterHoliday.vue';
import SettingCenterLecture from './views/madmin/setting/CenterLecture.vue';
import SettingCenterList from './views/madmin/setting/CenterList.vue';
import SettingCenterProgram from './views/madmin/setting/CenterProgram.vue';
import SettingCenterProgramExtension from './views/madmin/setting/CenterProgramExtension.vue';
import SettingEmployeeInfo from './views/madmin/setting/EmployeeInfo.vue';
import SettingEmployeeList from './views/madmin/setting/EmployeeList.vue';
import SettingEmployeeTeam from './views/madmin/setting/EmployeeTeam.vue';
import SettingGoodsCategory from './views/madmin/setting/GoodsCategory.vue';
import SettingGoodsPackage from './views/madmin/setting/GoodsPackage.vue';
import SettingGoodsPackageEdit from './views/madmin/setting/GoodsPackageEdit.vue';
import SettingGoodsUse from './views/madmin/setting/GoodsUse.vue';
import SettingGoodsUseDetail from './views/madmin/setting/GoodsUseDetail.vue';
import SettingLocker from './views/madmin/setting/Locker.vue';
import SettingLockerEdit from './views/madmin/setting/LockerEdit.vue';
import SettingMileage from './views/madmin/setting/Mileage.vue';
import SettingReservationApp from './views/madmin/setting/ReservationApp.vue';
import SettingReservationTeacher from './views/madmin/setting/ReservationTeacher.vue';
import SettingReservationTime from './views/madmin/setting/ReservationTime.vue';
import SettingRoom from './views/madmin/setting/Room.vue';
import SettingTouch from './views/madmin/setting/Touch.vue';
import SettingKiosk from './views/madmin/setting/Kiosk.vue';
import SettingElectronicContractManage from './views/madmin/setting/ElectronicContractManage.vue';
import SettingElectronicExternalDocument from './views/madmin/setting/ElectronicExternalDocument.vue';
import SettingElectronicTemplateManage from './views/madmin/setting/ElectronicTemplateManage.vue';
import SettingElectronicTemplateDetail from './views/madmin/setting/ElectronicTemplateDetail.vue';
import SettingElectronicSignature from './views/madmin/setting/ElectronicContractSignature.vue';
import SettingElectronicSetting from './views/madmin/setting/ElectronicSetting.vue';

import SalesAll from './views/madmin/sales/All.vue';
import SalesExpense from './views/madmin/sales/Expense.vue';
import SalesExpenseEdit from './views/madmin/sales/ExpenseEdit.vue';
import SalesExpenseSetting from './views/madmin/sales/ExpenseSetting.vue';
import SalesGoods from './views/madmin/sales/Goods.vue';
import SalesRefund from './views/madmin/sales/Refund.vue';
import SalesSell from './views/madmin/sales/Sell.vue';
import SalesSellEdit from './views/madmin/sales/SellEdit.vue';
import SalesSellModify from './views/madmin/sales/SellModify.vue';
import SalesSellSetting from './views/madmin/sales/SellSetting.vue';
import SalesStateManager from './views/madmin/sales/StateManager.vue';
import SalesFitPayment from './views/madmin/sales/FitPayment.vue';
import SalesFitSettlement from './views/madmin/sales/FitSettlement.vue';

import BoardDetail from './views/madmin/board/Detail.vue';
import BoardEdit from './views/madmin/board/Edit.vue';
import BoardList from './views/madmin/board/List.vue';
import MypageInfo from './views/madmin/mypage/Info.vue';
import MypageList from './views/madmin/mypage/List.vue';
import MypageReserve from './views/madmin/mypage/Reserve.vue';
import MypageSalary from './views/madmin/mypage/Salary.vue';
import MypageTime from './views/madmin/mypage/Time.vue';

import SalaryMonth from './views/madmin/salary/Month.vue';
import SalaryResult from './views/madmin/salary/Result.vue';
import SalaryUse from './views/madmin/salary/Use.vue';
import StatsEmployee from './views/madmin/stats/Employee.vue';
import StatsMember from './views/madmin/stats/Member.vue';
import StatsMonth from './views/madmin/stats/Month.vue';
import StatsPeriod from './views/madmin/stats/Period.vue';
import StatsSale from './views/madmin/stats/Sale.vue';
import StatsYear from './views/madmin/stats/Year.vue';

import HistoryAttendance from './views/madmin/history/Attendance.vue';
import HistoryEntrance from './views/madmin/history/Entrance.vue';
import HistoryAccessLog from './views/madmin/history/ClueAccessLog.vue';
import HistoryReserve from './views/madmin/history/Reserve.vue';

import ExcelClass from './views/madmin/excel/Class.vue';
import ExcelMember from './views/madmin/excel/Member.vue';
import ExcelSchedule from './views/madmin/excel/Schedule.vue';

import store from './store';
import touchComplete from './views/TouchComplete';
import touchMain from './views/TouchMain';
import touchNodata from './views/TouchNodata';
import touchReservation from './views/TouchReservation';

import MobileUserLogin from './views/mobile/user/UserLogin.vue';
import MobileUserSignContract from './views/mobile/user/SignContract.vue';
import MobileUserContractResult from './views/mobile/user/ContractResult.vue';
import MobileUserCheckContract from './views/mobile/center/CheckContract.vue';
import MobileAdminContractList from './views/mobile/admin/AdminContractList.vue';
import MobileAdminContractDetail from './views/mobile/admin/ContractDetail.vue';

import touchReservationMain from './views/TouchReservationMain';
import touchReservationTicket from './views/TouchReservationTicket';
import touchReservationAttendance from './views/TouchReservationAttendance';
import touchReservationEntrance from './views/TouchReservationEntrance';

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => {
        if (err.name !== 'NavigationDuplicated') throw err;
    });
};

Vue.use(Router);

const routes = {
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }
        return { x: 0, y: 0 };
    },
    routes: [
        {
            path: '/sample',
            name: 'sample',
            component: sample,
            meta: {
                gnbMenu: ['샘플'],
                requireAuth: false,
            },
        },
        {
            path: '/madmin/member/info/:id/sign',
            name: '전자계약서-직접서명',
            component: memberSign,
            meta: {
                gnbShow: false,
                gnbMenu: ['직접서명'],
                requireAuth: false,
            },
        },
        {
            path: '/login',
            name: 'login',
            component: adminLogin,
            meta: {
                gnbShow: false,
                gnbMenu: ['로그인'],
                requireAuth: false,
            },
        },
        {
            path: '/care/login',
            name: 'careLogin',
            component: careLogin,
            meta: {
                gnbShow: false,
                gnbMenu: ['로그인'],
                requireAuth: false,
            },
        },
        {
            path: '/:uid',
            name: 'MobileUserLogin',
            component: MobileUserLogin,
            meta: {
                gnbType: 'mobile',
                gnbShow: false,
                gnbMenu: ['로그인'],
                requireAuth: false,
            },
        },
        {
            path: '/careLogin',
            name: 'careLogin',
            component: careLogin,
            meta: {
                gnbShow: false,
                gnbMenu: ['로그인'],
                requireAuth: false,
            },
        },
        {
            path: '/admin/login',
            name: 'adminLogin',
            component: adminLogin,
            meta: {
                gnbShow: false,
                gnbMenu: ['로그인'],
                requireAuth: false,
            },
        },
        {
            path: '/',
            name: 'index',
            component: adminLogin,
            meta: {
                gnbShow: false,
                gnbMenu: ['인덱스'],
                requireAuth: false,
            },
        },
        {
            path: '/mobile/user/contract/:id',
            name: 'MobileUserSignContract',
            component: MobileUserSignContract,
            meta: {
                gnbType: 'mobile',
                gnbShow: false,
                gnbMenu: ['로그인'],
                requireAuth: false,
            },
        },
        {
            path: '/mobile/user/contract/result/:id',
            name: 'MobileUserContractResult',
            component: MobileUserContractResult,
            meta: {
                gnbType: 'mobile',
                gnbShow: false,
                gnbMenu: ['로그인'],
                requireAuth: false,
            },
        },
        {
            path: '/center/:id',
            name: 'MobileUserCheckContract',
            component: MobileUserCheckContract,
            meta: {
                gnbType: 'mobile',
                gnbShow: false,
                gnbMenu: ['로그인'],
                requireAuth: false,
            },
        },
        {
            path: '/mobile/admin/contract/list',
            name: 'MobileAdminContractList',
            component: MobileAdminContractList,
            meta: {
                gnbType: 'mobile',
                gnbShow: false,
                gnbMenu: ['로그인'],
                requireAuth: false,
            },
        },
        {
            path: '/mobile/admin/contract/detail/:id',
            name: 'MobileAdminContractDetail',
            component: MobileAdminContractDetail,
            meta: {
                gnbType: 'mobile',
                gnbShow: false,
                gnbMenu: ['로그인'],
                requireAuth: false,
            },
        },
        {
            path: '/touch/main',
            name: 'touchMain',
            component: touchMain,
            meta: {
                gnbShow: false,
                isTouch: true,
                gnbMenu: ['터치모니터'],
                requireAuth: false,
            },
        },
        {
            path: '/touch/reservation',
            name: 'touchReservation',
            component: touchReservation,
            meta: {
                gnbShow: false,
                isTouch: true,
                gnbMenu: ['터치모니터'],
                requireAuth: false,
            },
        },
        {
            path: '/touch/reservation/main',
            name: 'touchReservationMain',
            component: touchReservationMain,
            meta: {
                gnbShow: false,
                isTouch: true,
                gnbMenu: ['터치모니터'],
                requireAuth: false,
            },
        },
        {
            path: '/touch/reservation/ticket',
            name: 'touchReservationTicket',
            component: touchReservationTicket,
            meta: {
                gnbShow: false,
                isTouch: true,
                gnbMenu: ['터치모니터'],
                requireAuth: false,
            },
        },
        {
            path: '/touch/reservation/attendance',
            name: 'touchReservationAttendance',
            component: touchReservationAttendance,
            meta: {
                gnbShow: false,
                isTouch: true,
                gnbMenu: ['터치모니터'],
                requireAuth: false,
            },
        },
        {
            path: '/touch/reservation/entrance',
            name: 'touchReservationEntrance',
            component: touchReservationEntrance,
            meta: {
                gnbShow: false,
                isTouch: true,
                gnbMenu: ['터치모니터'],
                requireAuth: false,
            },
        },
        {
            path: '/touch/nodata',
            name: 'touchNodata',
            component: touchNodata,
            meta: {
                gnbShow: false,
                isTouch: true,
                gnbMenu: ['터치모니터'],
                requireAuth: false,
            },
        },
        {
            path: '/touch/complete',
            name: 'touchComplete',
            component: touchComplete,
            meta: {
                gnbShow: false,
                isTouch: true,
                gnbMenu: ['터치모니터'],
                requireAuth: false,
            },
        },

        {
            path: '/madmin/business/center/list',
            name: 'businessCenterList',
            component: businessCenterList,
            meta: {
                gnbMenu: ['업체관리', '센터관리'],
                keepAlive: true,
            },
        },
        {
            path: '/madmin/business/center/edit/',
            name: 'businessCenterEdit',
            component: businessCenterEdit,
            meta: {
                gnbMenu: ['업체관리', '센터관리', '센터수정'],
            },
        },
        {
            path: '/madmin/business/center/contract_list/:id',
            name: 'businessCenterContractList',
            component: businessCenterContractList,
            meta: {
                gnbMenu: ['업체관리', '센터관리', "전자계약서 발송 내역"],
            },
        },
        {
            path: '/madmin/business/fitpay/list',
            name: 'businessFitpayList',
            component: businessFitpayList,
            meta: {
                gnbMenu: ['업체관리', '핏페이관리'],
            },
        },
        {
            path: '/madmin/business/center/edit/:id',
            name: 'businessCenterEditId',
            component: businessCenterEdit,
            meta: {
                gnbMenu: ['업체관리', '센터관리', '센터수정'],
            },
        },
        {
            path: '/madmin/business/contract/list',
            name: 'businessContractList',
            component: businessContractList,
            meta: {
                gnbMenu: ['업체관리', '계약관리'],
            },
        },
        {
            path: '/madmin/business/contract/detail/:id',
            name: 'businessContractDetail',
            component: businessContractDetail,
            meta: {
                gnbMenu: ['업체관리', '계약관리', '상세'],
            },
        },
        {
            path: '/madmin/business/contract/refund/:contractId/:productId',
            name: 'businessContractRefund',
            component: businessContractRefund,
            meta: {
                gnbMenu: ['업체관리', '계약관리', '상세', '환불등록'],
            },
        },
        {
            path: '/madmin/business/contract/extension/:contractId/:productId',
            name: 'businessContractExtension',
            component: businessContractExtension,
            meta: {
                gnbMenu: ['업체관리', '계약관리', '상세', '연장결제'],
            },
        },
        {
            path: '/madmin/business/contract/edit',
            name: 'businessContractEdit',
            component: businessContractEdit,
            meta: {
                gnbMenu: ['업체관리', '계약관리', '상세', '계약등록'],
            },
        },
        {
            path: '/madmin/business/contract/edit/:id',
            name: 'businessContractEditId',
            component: businessContractEdit,
            meta: {
                gnbMenu: ['업체관리', '계약관리', '상세', '계약수정'],
            },
        },
        {
            path: '/madmin/business/contract/product',
            name: 'businessContractProduct',
            component: businessContractProduct,
            meta: {
                gnbMenu: ['업체관리', '계약관리', '상품설정'],
            },
        },
        {
            path: '/madmin/business/chain/list',
            name: 'businessChainList',
            component: businessChainList,
            meta: {
                gnbMenu: ['업체관리', '체인점관리'],
            },
        },
        {
            path: '/madmin/business/smsNumSetting',
            name: 'businessSmsNumSetting',
            component: businessSmsNumSetting,
            meta: {
                gnbMenu: ['업체관리', 'SMS(문자메시지)', 'SMS 발신번호 관리'],
            },
        },
        {
            path: '/madmin/noti/basic',
            name: 'notiBasic',
            component: notiBasic,
            meta: {
                gnbMenu: ['알림톡발송', '기본정보'],
            },
        },
        {
            path: '/madmin/noti/talk',
            name: 'notiTalk',
            component: notiTalk,
            meta: {
                gnbMenu: ['알림톡발송', '알림톡 발송내역'],
            },
        },
        {
            path: '/madmin/noti/template',
            name: 'notiTemplate',
            component: notiTemplate,
            meta: {
                gnbMenu: ['알림톡발송', '템플릿 관리'],
            },
        },
        {
            path: '/madmin/noti/status',
            name: 'notiStatus',
            component: notiStatus,
            meta: {
                gnbMenu: ['알림톡발송', '센터별발송현황'],
            },
        },
        {
            path: '/madmin/business/adminRefuseNum',
            name: 'businessAdminRefuseNum',
            component: adminRefuseNum,
            meta: {
                gnbMenu: ['업체관리', 'SMS(문자메시지)', 'SMS 수신거부번호 관리'],
            },
        },
        {
            path: '/madmin/business/smsPayment',
            name: 'businessSmsPayment',
            component: businessSmsPayment,
            meta: {
                gnbMenu: ['업체관리', 'SMS(문자메시지)', 'SMS 결제내역'],
            },
        },
        {
            path: '/madmin/employee/list',
            name: 'employeeList',
            component: employeeList,
            meta: {
                gnbMenu: ['직원관리'],
            },
        },
        {
            path: '/madmin/employee/edit',
            name: 'employeeEdit',
            component: employeeEdit,
            meta: {
                gnbMenu: ['직원관리', '직원정보'],
            },
        },
        {
            path: '/madmin/employee/edit/:id',
            name: 'employeeEditId',
            component: employeeEdit,
            meta: {
                gnbMenu: ['직원관리', '직원정보'],
            },
        },
        {
            path: '/madmin/notice/list',
            name: 'noticeList',
            component: noticeList,
            meta: {
                gnbMenu: ['공지사항', '게시판'],
                keepAlive: true,
            },
        },
        {
            path: '/madmin/notice/detail/:id',
            name: 'noticeDetail',
            component: noticeDetail,
            meta: {
                gnbMenu: ['공지사항', '게시판'],
            },
        },
        {
            path: '/madmin/notice/edit',
            name: 'noticeEdit',
            component: noticeEdit,
            meta: {
                gnbMenu: ['공지사항', '게시판'],
            },
        },
        {
            path: '/madmin/notice/edit/:id',
            name: 'noticeEditId',
            component: noticeEdit,
            meta: {
                gnbMenu: ['공지사항', '게시판'],
            },
        },
        {
            path: '/madmin/popup/list',
            name: 'popupList',
            component: popupList,
            meta: {
                gnbMenu: ['팝업관리'],
            },
        },
        {
            path: '/madmin/popup/detail/:id',
            name: 'popupDetail',
            component: popupDetail,
            meta: {
                gnbMenu: ['팝업관리'],
            },
        },
        {
            path: '/madmin/popup/edit',
            name: 'popupEdit',
            component: popupEdit,
            meta: {
                gnbMenu: ['팝업관리'],
            },
        },
        {
            path: '/madmin/popup/edit/:id',
            name: 'popupEditId',
            component: popupEdit,
            meta: {
                gnbMenu: ['팝업관리'],
            },
        },
        {
            path: '/madmin/question/list',
            name: 'questionList',
            component: questionList,
            meta: {
                gnbMenu: ['자주하는 질문', '게시판'],
            },
        },
        {
            path: '/madmin/question/detail/:id',
            name: 'questionDetail',
            component: questionDetail,
            meta: {
                gnbMenu: ['자주하는 질문', '게시판'],
            },
        },
        {
            path: '/madmin/question/edit',
            name: 'questionEdit',
            component: questionEdit,
            meta: {
                gnbMenu: ['자주하는 질문', '게시판'],
            },
        },
        {
            path: '/madmin/question/edit/:id',
            name: 'questionEditId',
            component: questionEdit,
            meta: {
                gnbMenu: ['자주하는 질문', '게시판'],
            },
        },

        {
            path: '/madmin/manual/list',
            name: 'manualList',
            component: manualList,
            meta: {
                gnbMenu: ['사용자 매뉴얼', '게시판'],
                keepAlive: true,
            },
        },
        {
            path: '/madmin/manual/detail/:id',
            name: 'manualDetail',
            component: manualDetail,
            meta: {
                gnbMenu: ['사용자 매뉴얼', '게시판'],
            },
        },
        {
            path: '/madmin/manual/edit',
            name: 'manualEdit',
            component: manualEdit,
            meta: {
                gnbMenu: ['사용자 매뉴얼', '게시판'],
            },
        },
        {
            path: '/madmin/manual/edit/:id',
            name: 'manualEditId',
            component: manualEdit,
            meta: {
                gnbMenu: ['사용자 매뉴얼', '게시판'],
            },
        },
        {
            path: '/madmin/qna/list',
            name: 'qnaList',
            component: qnaList,
            meta: {
                gnbMenu: ['1:1 문의하기', '게시판'],
            },
        },
        {
            path: '/madmin/qna/detail',
            name: 'qnaDetail',
            component: qnaDetail,
            meta: {
                gnbMenu: ['1:1 문의하기', '게시판'],
            },
        },
        {
            path: '/madmin/qna/detail/:id',
            name: 'qnaDetailId',
            component: qnaDetail,
            meta: {
                gnbMenu: ['1:1 문의하기', '게시판'],
            },
        },
        {
            path: '/madmin/qna/edit',
            name: 'qnaEdit',
            component: qnaEdit,
            meta: {
                gnbMenu: ['1:1 문의하기', '게시판'],
            },
        },
        {
            path: '/madmin/qna/edit/:id',
            name: 'qnaEditId',
            component: qnaEdit,
            meta: {
                gnbMenu: ['1:1 문의하기', '게시판'],
            },
        },
        {
            path: '/madmin/member/list',
            name: 'memberList',
            component: memberList,
            meta: {
                gnbMenu: ['회원', '회원관리'],
            },
        },
        {
            path: '/madmin/member/edit',
            name: 'memberEdit',
            component: memberEdit,
            meta: {
                gnbMenu: ['회원', '회원관리'],
            },
        },
        {
            path: '/madmin/member/account/:id',
            name: 'memberNew',
            component: memberAccount,
            meta: {
                gnbMenu: ['회원', '회원관리'],
            },
        },
        {
            path: '/madmin/member/info/:id',
            name: 'memberInfo',
            component: memberInfo,
            meta: {
                gnbMenu: ['회원', '회원관리'],
            },
        },
        {
            path: '/madmin/member/payment/:id',
            name: 'memberPayment',
            component: memberPayment,
            meta: {
                gnbMenu: ['회원', '회원관리'],
            },
        },
        {
            path: '/madmin/member/cancel/:id',
            name: 'memberCancel',
            component: memberCancel,
            meta: {
                gnbMenu: ['회원', '회원관리'],
            },
        },
        {
            path: '/madmin/member/attend/:id',
            name: 'memberAttend',
            component: memberAttend,
            meta: {
                gnbMenu: ['회원', '회원관리'],
            },
        },
        {
            path: '/madmin/member/mileage/:id',
            name: 'memberMileage',
            component: memberMileage,
            meta: {
                gnbMenu: ['회원', '회원관리'],
            },
        },
        {
            path: '/madmin/member/advice/:id',
            name: 'memberAdvice',
            component: memberAdvice,
            meta: {
                gnbMenu: ['회원', '회원관리'],
            },
        },
        {
            path: '/madmin/member/message/:id',
            name: 'memberMessage',
            component: memberMessage,
            meta: {
                gnbMenu: ['회원', '회원관리'],
            },
        },

        {
            path: '/madmin/member/contract_send/:id',
            name: 'memberContractSend',
            component: memberContractSend,
            meta: {
                gnbMenu: ['회원', '회원관리'],
            },
        },

        {
            path: '/madmin/member/period',
            name: 'memberPeriod',
            component: memberPeriod,
            meta: {
                gnbMenu: ['회원', '기간연장내역'],
            },
        },

        {
            path: '/madmin/member/consult',
            name: 'memberConsult',
            component: memberConsult,
            meta: {
                gnbMenu: ['회원', '상담관리'],
            },
        },
        {
            path: '/madmin/member/consult/detail/:id',
            name: 'memberConsultDetail',
            component: memberConsultDetail,
            meta: {
                gnbMenu: ['회원', '상담관리'],
            },
        },
        {
            path: '/madmin/member/locker',
            name: 'memberLocker',
            component: memberLocker,
            meta: {
                gnbMenu: ['회원', '락커내역'],
                keepAlive: true,
            },
        },
        {
            path: '/madmin/member/locker/edit/:lockerNo',
            name: 'memberLockerEdit',
            component: memberLockerEdit,
            meta: {
                gnbMenu: ['회원', '락커내역'],
            },
        },

        {
            path: '/madmin/message/send',
            name: 'messageSend',
            component: messageSend,
            meta: {
                gnbMenu: ['메시지', '메시지 발송', 'SMS(문자메시지)'],
            },
        },
        {
            path: '/madmin/message/send/alert',
            name: 'messageSendAlert',
            component: messageSendAlert,
            meta: {
                gnbMenu: ['메시지', '메시지 발송', '알림톡'],
            },
        },
        {
            path: '/madmin/message/send/auto',
            name: 'messageSendAuto',
            component: messageSendAuto,
            meta: {
                gnbMenu: ['메시지', '메시지 발송', 'SMS/알림톡 자동 발송'],
            },
        },
        {
            path: '/madmin/message/history',
            name: 'messageHistory',
            component: messageHistory,
            meta: {
                gnbMenu: ['메시지', '발송내역'],
            },
        },
        {
            path: '/madmin/message/setting/auto',
            name: 'messageSettingAuto',
            component: messageSettingAuto,
            meta: {
                gnbMenu: ['메시지', '메시지 내용설정', '자동발송 설정'],
            },
        },
        //추가
        // {
        //     path: '/madmin/message/refuseNum',
        //     name: 'messageRefuseNum',
        //     component: messageRefuseNum,
        //     meta: {
        //         gnbMenu: ['메시지', '발송내역', '수신거부번호'],
        //     },
        // },
        {
            path: '/madmin/message/setting/often',
            name: 'messageSettingOften',
            component: messageSettingOften,
            meta: {
                gnbMenu: ['메시지', '메시지 내용설정', '자주쓰는 문자'],
            },
        },
        {
            path: '/madmin/message/charge/call',
            name: 'messageChargeCall',
            component: messageChargeCall,
            meta: {
                gnbMenu: ['메시지', '충전내역 및 설정', '발신번호 설정'],
            },
        },
        {
            path: '/madmin/message/sms/charge',
            name: 'messageSmsCharge',
            component: messageSmsCharge,
            meta: {
                gnbMenu: ['메시지', 'SMS 충전'],
            },
        },

        {
            path: '/madmin/setting/employee/check',
            name: 'SettingEmployeeCheck',
            component: SettingEmployeeCheck,
            meta: {
                gnbMenu: ['직원설정', '직원노출여부'],
            },
        },
        {
            path: '/madmin/setting/member/group',
            name: 'SettingMemberGroup',
            component: SettingMemberGroup,
            meta: {
                gnbMenu: ['회원설정', '회원그룹설정'],
            },
        },
        {
            path: '/madmin/setting/member/notice/list',
            name: 'SettingMemberNoticeList',
            component: SettingMemberNoticeList,
            meta: {
                gnbMenu: ['회원설정', '회원공지사항'],
                keepAlive: true,
            },
        },
        {
            path: '/madmin/setting/member/notice/edit',
            name: 'SettingMemberNoticeEdit',
            component: SettingMemberNoticeEdit,
            meta: {
                gnbMenu: ['회원설정', '회원공지사항'],
            },
        },
        {
            path: '/madmin/setting/member/notice/edit/:id',
            name: 'SettingMemberNoticeEditId',
            component: SettingMemberNoticeEdit,
            meta: {
                gnbMenu: ['회원설정', '회원공지사항'],
            },
        },
        {
            path: '/madmin/setting/member/notice/detail',
            name: 'SettingMemberNoticeDetail',
            component: SettingMemberNoticeDetail,
            meta: {
                gnbMenu: ['회원설정', '회원공지사항'],
            },
        },
        {
            path: '/madmin/setting/member/notice/detail/:id/:centerId',
            name: 'SettingMemberNoticeDetailId',
            component: SettingMemberNoticeDetail,
            meta: {
                gnbMenu: ['회원설정', '회원공지사항'],
            },
        },
        {
            path: '/madmin/setting/member/pop/list',
            name: 'SettingMemberPopList',
            component: SettingMemberPopList,
            meta: {
                gnbMenu: ['회원설정', '회원팝업'],
                keepAlive: true,
            },
        },
        {
            path: '/madmin/setting/member/pop/edit',
            name: 'SettingMemberPopEdit',
            component: SettingMemberPopEdit,
            meta: {
                gnbMenu: ['회원설정', '회원팝업'],
            },
        },
        {
            path: '/madmin/setting/member/pop/edit/:id',
            name: 'SettingMemberPopEditId',
            component: SettingMemberPopEdit,
            meta: {
                gnbMenu: ['회원설정', '회원팝업'],
            },
        },
        {
            path: '/madmin/setting/member/pop/detail/:id',
            name: 'SettingMemberPopDetail',
            component: SettingMemberPopDetail,
            meta: {
                gnbMenu: ['회원설정', '회원팝업'],
            },
        },
        {
            path: '/madmin/center/main',
            name: 'CenterMain',
            component: CenterMain,
            meta: {
                gnbMenu: [''],
            },
        },

        {
            path: '/madmin/setting/goods/use',
            name: 'SettingGoodsUse',
            component: SettingGoodsUse,
            meta: {
                gnbMenu: ['센터설정', '상품관리', '이용권 관리'],
                keepAlive: true,
            },
        },
        {
            path: '/madmin/setting/goods/use/detail/:prodNo?',
            name: 'SettingGoodsUseDetail',
            component: SettingGoodsUseDetail,
            meta: {
                gnbMenu: ['센터설정', '상품관리', '이용권 관리'],
            },
            props: true,
        },
        {
            path: '/madmin/setting/goods/package',
            name: 'SettingGoodsPackage',
            component: SettingGoodsPackage,
            meta: {
                gnbMenu: ['센터설정', '상품관리', '패키지관리'],
            },
        },
        {
            path: '/madmin/setting/goods/package/edit/:prodNo?',
            name: 'SettingGoodsPackageEdit',
            component: SettingGoodsPackageEdit,
            meta: {
                gnbMenu: ['센터설정', '상품관리', '패키지관리'],
            },
            props: true,
        },
        {
            path: '/madmin/setting/goods/category',
            name: 'SettingGoodsCategory',
            component: SettingGoodsCategory,
            meta: {
                gnbMenu: ['센터설정', '상품관리', '카테고리 관리'],
            },
        },
        {
            path: '/madmin/setting/center/list',
            name: 'SettingCenterList',
            component: SettingCenterList,
            meta: {
                gnbMenu: ['센터설정', '센터관리'],
            },
        },
        {
            path: '/madmin/setting/center/:centerId/edit',
            name: 'SettingCenterEdit',
            component: SettingCenterEdit,
            meta: {
                gnbMenu: ['센터설정', '센터관리', '기본정보'],
            },
            props: true,
        },
        {
            path: '/madmin/setting/center/:centerId/program',
            name: 'SettingCenterProgram',
            component: SettingCenterProgram,
            meta: {
                gnbMenu: ['센터설정', '센터관리', '프로그램 가입내역'],
            },
            props: true,
        },
        {
            path: '/madmin/setting/center/:centerId/program/extension/:contractId/:productId',
            name: 'SettingCenterProgramExtension',
            component: SettingCenterProgramExtension,
            meta: {
                gnbMenu: [
                    '센터설정',
                    '센터관리',
                    '프로그램 가입내역',
                    '연장결제',
                ],
            },
            props: true,
        },
        {
            path: '/madmin/setting/center/:centerId/holiday',
            name: 'SettingCenterHoliday',
            component: SettingCenterHoliday,
            meta: {
                gnbMenu: ['센터설정', '센터관리', '휴일설정'],
            },
            props: true,
        },
        {
            path: '/madmin/setting/center/:centerId/account',
            name: 'SettingCenterAccount',
            component: SettingCenterAccount,
            meta: {
                gnbMenu: ['센터설정', '센터관리', '정산설정'],
            },
            props: true,
        },
        {
            path: '/madmin/setting/center/:centerId/payment/list',
            name: 'SettingCenterPaymentList',
            component: SettingCenterPaymentList,
            meta: {
                gnbMenu: ['센터설정', '센터관리', '결제내역'],
            },
            props: true,
        },
        {
            path: '/madmin/setting/center/:centerId/payment/method',
            name: 'SettingCenterPaymentMethod',
            component: SettingCenterPaymentMethod,
            meta: {
                gnbMenu: ['센터설정', '센터관리', '결제수단'],
            },
            props: true,
        },
        {
            path: '/madmin/setting/center/:centerId/fitpay',
            name: 'SettingCenterFitpay',
            component: SettingCenterFitpay,
            meta: {
                gnbMenu: ['센터설정', '센터관리', '핏페이'],
            },
            props: true,
        },
        {
            path: '/madmin/setting/center/:centerId/lecture',
            name: 'SettingCenterLecture',
            component: SettingCenterLecture,
            meta: {
                gnbMenu: ['센터설정', '센터관리', '교차수강설정'],
            },
            props: true,
        },
        {
            path: '/madmin/setting/locker',
            name: 'SettingLocker',
            component: SettingLocker,
            meta: {
                gnbMenu: ['센터설정', '락커'],
                keepAlive: true,
            },
        },
        {
            path: '/madmin/setting/locker/edit/:prodNo?',
            name: 'SettingLockerEdit',
            component: SettingLockerEdit,
            meta: {
                gnbMenu: ['센터설정', '락커'],
            },
            props: true,
        },
        {
            path: '/madmin/setting/mileage',
            name: 'SettingMileage',
            component: SettingMileage,
            meta: {
                gnbMenu: ['센터설정', '마일리지'],
            },
        },
        {
            path: '/madmin/setting/reservation/time',
            name: 'SettingReservationTime',
            component: SettingReservationTime,
            meta: {
                gnbMenu: ['센터설정', '예약시간 설정'],
            },
        },
        {
            path: '/madmin/setting/reservation/app',
            name: 'SettingReservationApp',
            component: SettingReservationApp,
            meta: {
                gnbMenu: ['센터설정', '예약시간 설정', '회원예약 앱'],
            },
        },
        {
            path: '/madmin/setting/reservation/teacher',
            name: 'SettingReservationTeacher',
            component: SettingReservationTeacher,
            meta: {
                gnbMenu: ['센터설정', '예약시간 설정', '강사수업 예약'],
            },
        },
        {
            path: '/madmin/setting/touch',
            name: 'SettingTouch',
            component: SettingTouch,
            meta: {
                gnbMenu: ['센터설정', '터치모니터'],
            },
        },
        {
            path: '/madmin/setting/kiosk',
            name: 'SettingTouch',
            component: SettingKiosk,
            meta: {
                gnbMenu: ['센터설정', '키오스크'],
            },
        },
        {
            path: '/madmin/setting/electronic/contract/manage',
            name: 'SettingElectronicContractManage',
            component: SettingElectronicContractManage,
            meta: {
                gnbMenu: ['센터설정', '전자계약'],
            },
        },
        {
            path: '/madmin/setting/electronic/external/document',
            name: 'SettingElectronicExternalDocument',
            component: SettingElectronicExternalDocument,
            meta: {
                gnbMenu: ['센터설정', '전자계약'],
            },
        },
        {
            path: '/madmin/setting/electronic/template/manage',
            name: 'SettingElectronicTemplateManage',
            component: SettingElectronicTemplateManage,
            meta: {
                gnbMenu: ['센터설정', '전자계약'],
            },
        },
        {
            path: '/madmin/setting/electronic/template/detail',
            name: 'SettingElectronicTemplateDetail',
            component: SettingElectronicTemplateDetail,
            meta: {
                gnbMenu: ['센터설정', '전자계약'],
            },
        },
        {
            path: '/madmin/setting/electronic/signature',
            name: 'SettingElectronicSignature',
            component: SettingElectronicSignature,
            meta: {
                gnbMenu: ['센터설정', '전자계약'],
            },
        },
        {
            path: '/madmin/setting/electronic/setting',
            name: 'SettingElectronicSetting',
            component: SettingElectronicSetting,
            meta: {
                gnbMenu: ['센터설정', '전자계약'],
            },
        },
        {
            path: '/madmin/setting/advertisement',
            name: 'SettingAdvertisement',
            component: SettingAdvertisement,
            meta: {
                gnbMenu: ['광고관리'],
            },
        },
        {
            path: '/madmin/setting/author',
            name: 'SettingAuthor',
            component: SettingAuthor,
            meta: {
                gnbMenu: ['센터설정', '권한구성'],
            },
        },
        {
            path: '/madmin/setting/author/:roleId',
            name: 'SettingAuthorDetail',
            component: SettingAuthorDetail,
            meta: {
                gnbMenu: ['센터설정', '권한구성'],
            },
        },
        {
            path: '/madmin/setting/room',
            name: 'SettingRoom',
            component: SettingRoom,
            meta: {
                gnbMenu: ['센터설정', '룸 관리'],
            },
        },
        {
            path: '/madmin/setting/employee/list',
            name: 'SettingEmployeeList',
            component: SettingEmployeeList,
            meta: {
                gnbMenu: ['직원설정', '직원관리'],
            },
        },
        {
            path: '/madmin/setting/employee/info/:centerStaffId?',
            name: 'SettingEmployeeInfo',
            component: SettingEmployeeInfo,
            meta: {
                gnbMenu: ['직원설정', '직원관리'],
            },
        },
        {
            path: '/madmin/setting/employee/team',
            name: 'SettingEmployeeTeam',
            component: SettingEmployeeTeam,
            meta: {
                gnbMenu: ['직원설정', '팀 설정'],
            },
        },

        {
            path: '/madmin/schedule/day',
            name: 'ScheduleDay',
            component: ScheduleDay,
            meta: {
                gnbMenu: ['스케줄', '일일스케줄'],
            },
        },
        {
            path: '/madmin/schedule/group',
            name: 'ScheduleGroup',
            component: ScheduleGroup,
            meta: {
                gnbMenu: ['스케줄', '그룹 주간표'],
            },
        },
        {
            path: '/madmin/schedule/teacher',
            name: 'scheduleTeacher',
            component: scheduleTeacher,
            meta: {
                gnbMenu: ['스케줄', '강사 주간표'],
            },
        },
        {
            path: '/madmin/schedule/room',
            name: 'scheduleRoom',
            component: scheduleRoom,
            meta: {
                gnbMenu: ['스케줄', '룸 스케줄표'],
            },
        },
        {
            path: '/madmin/course/care',
            name: 'CourseCare',
            component: CourseCare,
            meta: {
                gnbMenu: ['수업', '수업관리'],
            },
        },
        {
            path: '/madmin/course/care/reserve',
            name: 'CourseCareReserve',
            component: CourseCareReserve,
            meta: {
                gnbMenu: ['수업', '수업관리', '스케줄 예약'],
            },
            props: true,
        },
        {
            path: '/madmin/course/care/history/',
            name: 'CourseCareHistory',
            component: CourseCareHistory,
            meta: {
                gnbMenu: ['수업', '수업관리', '이용권', '히스토리'],
            },
        },
        {
            path: '/madmin/course/account/:id',
            name: 'CourseAccount',
            component: memberAccount,
            meta: {
                gnbMenu: ['수업', '수업 및 정산'],
            },
        },
        {
            path: '/madmin/course/account',
            name: 'CourseAccount',
            component: CourseAccount,
            meta: {
                gnbMenu: ['수업', '수업 및 정산'],
            },
        },
        {
            path: '/madmin/course/lesson',
            name: 'CourseLesson',
            component: CourseLesson,
            meta: {
                gnbMenu: ['수업', '그룹레슨 관리'],
                keepAlive: true,
            },
        },
        {
            path: '/madmin/course/history/',
            name: 'CourseHistory',
            component: CourseHistory,
            meta: {
                gnbMenu: ['수업', '그룹레슨 관리', '히스토리 내역'],
            },
        },
        {
            path: '/madmin/sales/goods',
            name: 'SalesGoods',
            component: SalesGoods,
            meta: {
                gnbMenu: ['매출', '매출현황(상품)'],
                keepAlive: true,
            },
        },
        {
            path: '/madmin/sales/fitpay/payment',
            name: 'SalesFitPayment',
            component: SalesFitPayment,
            meta: {
                gnbMenu: ['매출', '핏페이 매출', '결제내역'],
            },
        },
        {
            path: '/madmin/sales/fitpay/settlement',
            name: 'SalesFitSettlement',
            component: SalesFitSettlement,
            meta: {
                gnbMenu: ['매출', '핏페이 매출', '정산내역'],
            },
        },
        {
            path: '/madmin/sales/all',
            name: 'SalesAll',
            component: SalesAll,
            meta: {
                gnbMenu: ['매출', '매출현황(전체)'],
                keepAlive: true,
            },
        },
        {
            path: '/madmin/sales/sell',
            name: 'SalesSell',
            component: SalesSell,
            meta: {
                gnbMenu: ['매출', '판매등록'],
            },
        },
        {
            path: '/madmin/sales/sell/edit',
            name: 'SalesSellEdit',
            component: SalesSellEdit,
            meta: {
                gnbMenu: ['매출', '판매등록'],
            },
        },
        {
            path: '/madmin/sales/sell/modify',
            name: 'SalesSellModify',
            component: SalesSellModify,
            meta: {
                gnbMenu: ['매출', '판매등록'],
            },
        },
        {
            path: '/madmin/sales/setting',
            name: 'SalesSellSetting',
            component: SalesSellSetting,
            meta: {
                gnbMenu: ['매출', '판매등록', '판매설정'],
            },
        },
        {
            path: '/madmin/sales/expense',
            name: 'SalesExpense',
            component: SalesExpense,
            meta: {
                gnbMenu: ['매출', '지출등록'],
            },
        },
        {
            path: '/madmin/sales/expense/edit',
            name: 'SalesExpenseEdit',
            component: SalesExpenseEdit,
            meta: {
                gnbMenu: ['매출', '지출등록'],
            },
        },
        {
            path: '/madmin/sales/expense/setting',
            name: 'SalesExpenseSetting',
            component: SalesExpenseSetting,
            meta: {
                gnbMenu: ['매출', '지출등록'],
            },
        },
        {
            path: '/madmin/sales/refund',
            name: 'SalesRefund',
            component: SalesRefund,
            meta: {
                gnbMenu: ['매출', '환불관리'],
            },
        },
        {
            path: '/madmin/board/list',
            name: 'BoardList',
            component: BoardList,
            meta: {
                gnbMenu: ['업무게시판', '업무전달'],
                keepAlive: true,
            },
        },
        {
            path: '/madmin/board/edit',
            name: 'BoardEdit',
            component: BoardEdit,
            meta: {
                gnbMenu: ['업무게시판', '업무전달'],
            },
        },
        {
            path: '/madmin/board/edit/:centerId/:centerTaskId',
            name: 'BoardModifyEdit',
            component: BoardEdit,
            meta: {
                gnbMenu: ['업무게시판', '업무전달'],
            },
        },
        {
            path: '/madmin/board/detail/:centerId/:centerTaskId',
            name: 'BoardDetail',
            component: BoardDetail,
            meta: {
                gnbMenu: ['업무게시판', '업무전달'],
            },
        },
        {
            path: '/madmin/mypage/list',
            name: 'MypageList',
            component: MypageList,
            meta: {
                gnbMenu: ['마이페이지', '담당회원확인'],
                keepAlive: true,
            },
        },
        {
            path: '/madmin/mypage/reserve',
            name: 'MypageReserve',
            component: MypageReserve,
            meta: {
                gnbMenu: ['마이페이지', '예약/취소 내역'],
            },
        },
        {
            path: '/madmin/mypage/info',
            name: 'MypageInfo',
            component: MypageInfo,
            meta: {
                gnbMenu: ['마이페이지', '개인정보설정'],
            },
        },
        {
            path: '/madmin/mypage/time',
            name: 'MypageTime',
            component: MypageTime,
            meta: {
                gnbMenu: ['마이페이지', '개인정보설정'],
            },
        },
        {
            path: '/madmin/mypage/salary',
            name: 'MypageSalary',
            component: MypageSalary,
            meta: {
                gnbMenu: ['마이페이지', '인사정보'],
            },
        },
        {
            path: '/madmin/salary/month',
            name: 'SalaryMonth',
            component: SalaryMonth,
            meta: {
                gnbMenu: ['급여', '월별정산'],
            },
        },
        {
            path: '/madmin/salary/result',
            name: 'SalaryResult',
            component: SalaryResult,
            meta: {
                gnbMenu: ['급여', '성과보고서'],
            },
        },
        {
            path: '/madmin/salary/use',
            name: 'SalaryUse',
            component: SalaryUse,
            meta: {
                gnbMenu: ['급여', '이용권 정산내역'],
            },
        },
        {
            path: '/madmin/stats/month',
            name: 'StatsMonth',
            component: StatsMonth,
            meta: {
                gnbMenu: ['통계', '운영보고서', '월간 보고서'],
            },
        },
        {
            path: '/madmin/stats/period',
            name: 'StatsPeriod',
            component: StatsPeriod,
            meta: {
                gnbMenu: ['통계', '운영보고서', '기간별 보고서'],
            },
        },
        {
            path: '/madmin/stats/year',
            name: 'StatsYear',
            component: StatsYear,
            meta: {
                gnbMenu: ['통계', '운영보고서', '연간 보고서'],
            },
        },
        {
            path: '/madmin/stats/sale',
            name: 'StatsSale',
            component: StatsSale,
            meta: {
                gnbMenu: ['통계', '매출통계'],
            },
        },
        {
            path: '/madmin/stats/employee',
            name: 'StatsEmployee',
            component: StatsEmployee,
            meta: {
                gnbMenu: ['통계', '직원통계'],
            },
        },
        {
            path: '/madmin/stats/member',
            name: 'StatsMember',
            component: StatsMember,
            meta: {
                gnbMenu: ['통계', '회원이용통계'],
            },
        },
        // 중복 코드
        //   {
        //       path: '/madmin/stats/member',
        //       name: 'StatsMember',
        //       component: StatsMember,
        //       meta: {
        //           gnbMenu: ['통계', '회원이용통계'],
        //       },
        //   },
        {
            path: '/madmin/history/attendance',
            name: 'HistoryAttendance',
            component: HistoryAttendance,
            meta: {
                gnbMenu: ['히스토리', '출석현황'],
                keepAlive: true,
            },
        },
        {
            path: '/madmin/history/reserve',
            name: 'HistoryReserve',
            component: HistoryReserve,
            meta: {
                gnbMenu: ['히스토리', '예약취소내역'],
                keepAlive: true,
            },
        },
        {
            path: '/madmin/history/entrance',
            name: 'HistoryEntrance',
            component: HistoryEntrance,
            meta: {
                gnbMenu: ['히스토리', '입장내역'],
                keepAlive: true,
            },
        },
        {
            path: '/madmin/history/access-log',
            name: 'HistoryAccessLog',
            component: HistoryAccessLog,
            meta: {
                gnbMenu: ['히스토리', '출입기록'],
                keepAlive: true,
            },
        },
        {
            path: '/madmin/sales/state/manager',
            name: 'SalesStateManager',
            component: SalesStateManager,
            meta: {
                gnbMenu: ['매출관리', '매출현황'],
            },
        },
        {
            path: '/madmin/excel/member/',
            name: 'ExcelMember',
            component: ExcelMember,
            meta: {
                gnbMenu: ['엑셀 일괄업로드', '회원관리'],
            },
        },
        {
            path: '/madmin/excel/class/',
            name: 'ExcelClass',
            component: ExcelClass,
            meta: {
                gnbMenu: ['엑셀 일괄업로드', '수업관리'],
            },
        },
        {
            path: '/madmin/excel/schedule/',
            name: 'ExcelSchedule',
            component: ExcelSchedule,
            meta: {
                gnbMenu: ['엑셀 일괄업로드', '스케줄예약'],
            },
        },
        {
            path: '/madmin/payComplete',
            name: 'payComplete',
            component: payComplete,
            meta: {
                gnbShow: false,
                requireAuth: false,
            },
        },
        // {
        //     path: '/madmin/author/list',
        //     name: 'authorList',
        //     component: authorList,
        //     meta: {
        //         gnbMenu: ['권한설정'],
        //     },
        // },
        // {
        //     path: '/madmin/author/detail/:id',
        //     name: 'authorDetail',
        //     component: authorDetail,
        //     meta: {
        //         gnbMenu: ['권한설정'],
        //     },
        // },
        // {
        //     path: '/madmin/author/edit',
        //     name: 'authorEdit',
        //     component: authorEdit,
        //     meta: {
        //         gnbMenu: ['권한설정'],
        //     },
        // },
        // {
        //     path: '/madmin/message/charge/history',
        //     name: 'messageChargeHistory',
        //     component: messageChargeHistory,
        //     meta: {
        //         gnbMenu: ['메시지', '충전내역 및 설정', '충전내역 확인'],
        //     },
        // },
        // {
        //     path: '/madmin/setting/employee/salary/:centerStaffId?',
        //     name: 'SettingEmployeeSalary',
        //     component: SettingEmployeeSalary,
        //     meta: {
        //         gnbMenu: ['직원설정', '직원관리'],
        //     },
        // },
        // {
        //     path: '/madmin/setting/employee/time/:centerStaffId?',
        //     name: 'SettingEmployeeTime',
        //     component: SettingEmployeeTime,
        //     meta: {
        //         gnbMenu: ['직원설정', '직원관리'],
        //     },
        // },
        // {
        //     path: '/madmin/setting/employee/setup',
        //     name: 'SettingEmployeeSetup',
        //     component: SettingEmployeeSetup,
        //     meta: {
        //         gnbMenu: ['직원설정', '직원권한설정'],
        //     },
        // },

        // {
        //     path: '/madmin/course/care/edit/:id',
        //     name: 'CourseCareEdit',
        //     component: CourseCareEdit,
        //     meta: {
        //         gnbMenu: ['수업', '수업관리', '이용권'],
        //     },
        //     props: true,
        // },

        // {
        //     path: '/madmin/account/sales/tax',
        //     name: 'AccountSalesTax',
        //     component: AccountSalesTax,
        //     meta: {
        //         gnbMenu: ['경리나라', '매출'],
        //     },
        // },
        // {
        //     path: '/madmin/account/sales/card',
        //     name: 'AccountSalesCard',
        //     component: AccountSalesCard,
        //     meta: {
        //         gnbMenu: ['경리나라', '매출'],
        //     },
        // },
        // {
        //     path: '/madmin/account/sales/cash',
        //     name: 'AccountSalesCash',
        //     component: AccountSalesCash,
        //     meta: {
        //         gnbMenu: ['경리나라', '매출'],
        //     },
        // },
        // {
        //     path: '/madmin/account/sales/etc',
        //     name: 'AccountSalesEtc',
        //     component: AccountSalesEtc,
        //     meta: {
        //         gnbMenu: ['경리나라', '매출'],
        //     },
        // },
        // {
        //     path: '/madmin/account/purchase/tax',
        //     name: 'AccountPurchaseTax',
        //     component: AccountPurchaseTax,
        //     meta: {
        //         gnbMenu: ['경리나라', '매입'],
        //     },
        // },
        // {
        //     path: '/madmin/account/purchase/card',
        //     name: 'AccountPurchaseCard',
        //     component: AccountPurchaseCard,
        //     meta: {
        //         gnbMenu: ['경리나라', '매입'],
        //     },
        // },
        // {
        //     path: '/madmin/account/purchase/cash',
        //     name: 'AccountPurchaseCash',
        //     component: AccountPurchaseCash,
        //     meta: {
        //         gnbMenu: ['경리나라', '매입'],
        //     },
        // },
        // {
        //     path: '/madmin/account/finance/bank',
        //     name: 'AccountFinanceBank',
        //     component: AccountFinanceBank,
        //     meta: {
        //         gnbMenu: ['경리나라', '금융'],
        //     },
        // },
        // {
        //     path: '/madmin/account/finance/deal',
        //     name: 'AccountFinanceDeal',
        //     component: AccountFinanceDeal,
        //     meta: {
        //         gnbMenu: ['경리나라', '금융'],
        //     },
        // },
        /**
         *
         * /madmin/account/purchase/list
         * /madmin/account/finance/list
         */
        //   {
        //       path: '*',
        //       component: NotFound,
        //       meta: { gnbShow: false },

        //   },
        /*
			{ path: '/user/:id', component: User,
			 //<h2>User {{ $route.params.id }}</h2>
			  children: [
				{
				  // /user/:id/profile 과 일치 할 때
				  // UserProfile은 User의 <router-view> 내에 렌더링 됩니다.
				  path: 'profile',
				  component: UserProfile
				},
				{
				  // /user/:id/posts 과 일치 할 때
				  // UserPosts가 User의 <router-view> 내에 렌더링 됩니다.

				  path: 'posts',
				  component: UserPosts
				}
			  ]
			},
			{
			  path: '/testing',
			  name: 'testing',
			  component: () => import('@/views/Testing.vue'),
			},
			{
			  path: '/icons',
			  name: 'icons',
			  component: () => import('@/views/Icons.vue'),
			},
			{
			  path: '/bootstrap',
			  name: 'bootstrap',
			  component: () => import('@/views/Boostrap.vue'),
			},
			*/
    ],
};

const router = new Router(routes);

router.beforeEach((to, from, next) => {
    localStorage.setItem('previousPath', from.path);
    if (to.meta.requireAuth !== false || to.meta.requireAuth === true) {
        if (store.state.auth.user) {
            next();
        } else {
            next('/login?returnPathName=businessCenterList');
        }
    } else {
        next();
    }
});

export default router;
